import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryIcons: Record<string, string> = {
  hanman: 'ri-global-line',
  riman: 'ri-earth-line',
  guoman: 'ri-flag-line',
  wanjie: 'ri-check-double-line',
  paihang: 'ri-bar-chart-line',
  tuijian: 'ri-thumb-up-line',
};

const categoryIconBgMap: Record<string, string> = {
  hanman: 'bg-primary-100 group-hover:bg-primary-200',
  riman: 'bg-accent-100 group-hover:bg-accent-200',
  guoman: 'bg-secondary-100 group-hover:bg-secondary-200',
  wanjie: 'bg-primary-100 group-hover:bg-primary-200',
  paihang: 'bg-accent-100 group-hover:bg-accent-200',
  tuijian: 'bg-secondary-100 group-hover:bg-secondary-200',
};

const categoryIconColorMap: Record<string, string> = {
  hanman: 'text-primary-500',
  riman: 'text-accent-500',
  guoman: 'text-secondary-500',
  wanjie: 'text-primary-500',
  paihang: 'text-accent-500',
  tuijian: 'text-secondary-500',
};

export default function CategorySection() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-800">
              漫画分类
            </h2>
            <p className="text-sm text-foreground-500 mt-1">探索不同类型的精彩漫画</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={scrollToTop}
              className="group relative bg-background-50 rounded-xl p-4 md:p-5 border border-secondary-200/60 hover:border-primary-300 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl ${categoryIconBgMap[cat.slug]} flex items-center justify-center mb-3 transition-colors duration-300`}>
                <i className={`${categoryIcons[cat.slug]} text-xl md:text-2xl ${categoryIconColorMap[cat.slug]}`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 mb-2 hidden sm:block">
                {cat.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.count.toLocaleString()} 部
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}